import { Heading, SegmentedTabs, Text } from "@overmap-ai/blocks"
import { selectAttachmentsOfFormRevision, selectFormById, selectFormRevisionById } from "@overmap-ai/core"
import { FormBuilder } from "@overmap-ai/forms"
import { getRouteApi } from "@tanstack/react-router"
import { memo } from "react"

import { ViewContainer } from "../../components/Containers/ViewContainer"
import { useDeserializeFieldSchemaConfig, useHydrateFieldsWithAttachments } from "../../components/Form/hooks"
import { sdk } from "../../sdk"
import { useAppSelector, useShallowEqaulSelector } from "../../store"

const routeApi = getRouteApi("/_loggedIn/$organizationId/_map/_layout/settings/forms/$formId/revisions/$formRevisionId")

export const FormRevisionSettingsDetailView = memo(() => {
	const { formId, formRevisionId } = routeApi.useParams()
	const form = useAppSelector(selectFormById(formId))
	const formRevision = useAppSelector(selectFormRevisionById(formRevisionId))
	const attachmentsOfRevision = useShallowEqaulSelector(selectAttachmentsOfFormRevision(formRevisionId))

	if (!form || !formRevision) {
		throw new Error(`Expected form revision ${formRevisionId} and form ${formId} to exist.`)
	}

	const revisionLabel = formRevision.revision === undefined ? "Pending revision" : `Revision ${formRevision.revision}`
	const fieldSchemaConfig = useDeserializeFieldSchemaConfig(formRevision.fields)

	const fieldsWithImages = useHydrateFieldsWithAttachments(
		fieldSchemaConfig,
		attachmentsOfRevision,
		sdk.formRevisionAttachments,
	)

	return (
		<ViewContainer>
			<section className="flex size-full flex-col gap-4 overflow-hidden">
				<Heading size="xl" className="shrink-0 truncate">
					{form.name}
					&nbsp;
					<Text accentColor="base">{revisionLabel}</Text>
				</Heading>

				<FormBuilder.Root initialFields={fieldsWithImages} hideSave hideCancel>
					<SegmentedTabs.Root
						defaultValue="edit"
						className="flex min-h-0 w-full grow flex-col gap-4 overflow-hidden"
					>
						<SegmentedTabs.List className="flex" accentColor="base" size="sm" variant="surface">
							<SegmentedTabs.Trigger className="grow basis-1" value="edit">
								List
							</SegmentedTabs.Trigger>
							<SegmentedTabs.Trigger className="grow basis-1" value="flow">
								Flow
							</SegmentedTabs.Trigger>
							<SegmentedTabs.Trigger className="grow basis-1" value="preview">
								Preview
							</SegmentedTabs.Trigger>
						</SegmentedTabs.List>

						<SegmentedTabs.Content value="edit" className="size-full overflow-y-auto overflow-x-clip">
							<FormBuilder.ListBuilder />
						</SegmentedTabs.Content>

						<SegmentedTabs.Content value="flow" className="size-full overflow-y-auto overflow-x-clip">
							<FormBuilder.FlowBuilder />
						</SegmentedTabs.Content>

						<SegmentedTabs.Content value="preview" className="size-full overflow-y-auto overflow-x-clip">
							<FormBuilder.Preview />
						</SegmentedTabs.Content>
					</SegmentedTabs.Root>
				</FormBuilder.Root>
			</section>
		</ViewContainer>
	)
})
FormRevisionSettingsDetailView.displayName = "FormRevisionSettingsDetailView"
